<template>
  <header class="header-desktop">
    <div class="section__content section__content--p30">
      <div class="container-fluid">
        <div class="header-wrap">
          <div>
            <h1 style="color: #e1e1e1;">
              <i class="fa fa-globe p-r-10" v-if="projectTitle === 'CDN'"></i>
              <i class="fa fa-file-video p-r-10" v-if="projectTitle === 'File Transcoding'"></i>
              <i class="fa fa-play-circle p-r-10" v-if="projectTitle === 'Live Transcoding'"></i>
              {{ text(projectTitle) }}
            </h1>
          </div>
          <div>
            <!--v-btn color dark icon class="m-r-0" @click="setLocale('ru')">
              <v-avatar size="24">
                <img
                  :class="{'menu-lang-disabled': locale !== 'ru' }"
                  src="/flags/1x1/ru.svg"
                  alt
                />
              </v-avatar>
            </v-btn>
            <v-btn color dark icon class="m-l-0 m-r-10" @click="setLocale('en')">
              <v-avatar size="24" disabled>
                <img
                  :class="{'menu-lang-disabled': locale !== 'en' }"
                  src="/flags/1x1/us.svg"
                  alt
                />
              </v-avatar>
            </v-btn-->
            <b-dropdown :text="name" variant="link" class="account-dropdown">
              <b-dropdown-item @click.prevent="goToProfile()">
                <a href="javascript:void(0)">
                  <i class="zmdi zmdi-account"></i> {{ text('profile') }}
                </a>
              </b-dropdown-item>
              <b-dropdown-item @click.prevent="onLogout">
                <a href="javascript:void(0)">
                  <i class="zmdi zmdi-power"></i>{{ text('logout') }}
                </a>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <app-loader v-if="loading"></app-loader>
  </header>
</template>

<script>

export default {
  computed: {
    projectTitle() {
      return this.$store.getters.projectTitle;
    },
    email() {
      return this.$store.getters.getUsername ? this.$store.getters.getUsername : '';
    },
    name() {
      if (this.$store.getters.user && this.$store.getters.user.name) {
        return this.$store.getters.user.name;
      }
      return this.email;
    },
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    locale() {
      return this.$store.getters.locale;
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  created() {
  },
  methods: {
    goToProfile() {
      this.$router.push({ name: 'ProfileInfoPage' });
    },
    onLogout() {
      this.$store.dispatch('logout');
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return '';
    },
    setLocale(code) {
      this.$store.dispatch('setLocale', code);
    },
  },
};
</script>

<style>
.v-menu__content {
  z-index: 99999 !important;
}
</style>
